import { contextFactory } from '../../../../../factories/contextFactory.js';

/**
 * @internal Not for public usage
 */
const [ColumnsSettingContext, useColumnsSettingContext] = contextFactory();

export { ColumnsSettingContext, useColumnsSettingContext };
//# sourceMappingURL=ColumnsSettingContext.js.map
